import rg4js from "raygun4js";
import ZipAnalytics, { analytics } from "./zipAnalytics";
import { MixpanelZipAnalyticsBrowser } from "./mixpanel/mixpanelZipAnalyticsBrowser";

export function initializeAnaytics() {
    if (window.location.hostname != 'localhost') {
        const host = window.location.hostname.toLowerCase();
        const isStage = (host.indexOf('dev') != -1 || host.indexOf('stage') != -1);
        rg4js('options', { debugMode: false, captureUnhandledRejections: true });
        rg4js('enableCrashReporting', true);
        rg4js('enablePulse', false);
        rg4js('withTags', ['outreach', 'web', (isStage ? 'stage' : 'production')]);
        rg4js('apiKey', 'Ie7Ifb8xwFOL1VGcgUaAvA');
        rg4js('withCustomData', { buildTime: process.env.REACT_APP_BUILD_TIME });

        analytics.registerModule(ZipAnalytics.MIXPANEL_KEY,
            new MixpanelZipAnalyticsBrowser(
                isStage ? 'f8be12ef894e00f9223028a2b065cb38'
                : '344acd33202a33d68412b9dc3dabdf23', {
                ip: true
            })
        );
    }
}